import { useTranslation } from 'react-i18next'

/** Toggles the active locale (es ⇄ en). Spanish is primary. */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation()
  const current = i18n.resolvedLanguage ?? 'es'

  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="text-neutral-500">{t('lang.label')}</span>
      <select
        aria-label={t('lang.label')}
        value={current}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
        className="rounded border border-neutral-300 bg-white px-2 py-1 dark:bg-neutral-800"
      >
        <option value="es">{t('lang.es')}</option>
        <option value="en">{t('lang.en')}</option>
      </select>
    </label>
  )
}
